import { Component, OnInit, ElementRef, Input, HostBinding, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { Validator, ValidationResults, ValidationInfo, AvailabilityDict } from 'src/app/model/validator';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

@Component({
	selector: 'app-input',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputComponent implements OnInit, OnDestroy {

	public validationStates: StatefulCSS;
	public reqStates: StatefulCSS;
	public modStates: StatefulCSS;
	public describeId = '';
	public hasDescription = false;
	public description = '';
	public labelId = '';
	public label = '';
	public validationError = '';
	public isRequired = false;
	public initialized = false;
	protected subscriptions = new SubScriptionMgr();
	@HostBinding('class.data-entry-input') isInput = true;
	@Input()
	public layer: SLLayer;
	@Input()
	public attribute: AttributeInfo;

	@Input()
	public validator: Validator = null;

	protected _domNode: ElementRef<any>;

	public set currentValue(val: any) {
		this.validator.SetValue(this.attribute.name, val);
	}
	public get currentValue(): any {
		return this.validator.GetValue(this.attribute.name);
	}

	protected get hasCasting(): boolean {
		if (!!this.attribute.casting) {
			if (!!this.attribute.casting.entry) {
				return true;
			}
		}
		return false;
	}
	protected get casting(): CastingValue {
		return this.attribute.casting.entry;
	}
	constructor(protected cdr: ChangeDetectorRef) { }

	ngOnInit(): void {
		this.validationStates = new StatefulCSS(['valid', 'invalid'], this._domNode.nativeElement, 'validity', 'valid');
		this.reqStates = new StatefulCSS(['required', 'optional'], this._domNode.nativeElement, 'reqs', 'optional');
		this.modStates = new StatefulCSS(['unmodified', 'modified'], this._domNode.nativeElement, 'unmodified', 'mods');

		if (!!this.attribute.description) {
			if (this.attribute.description !== '') {
				this.describeId = this.attribute.name + '-description';
				this.description = this.attribute.description;
				this.hasDescription = true;
			}
		}
		this.subscriptions.Subscribe(
			this.validator.validityChange, (changes: ValidationResults) => {
				const change: ValidationInfo = changes.validMap[this.attribute.name];
				let isValid = true;
				let problem = '';
				if (!change) {
					if (this.attribute.casting && this.attribute.casting.entry) {
						if (this.attribute.casting.entry.require === true) {
							isValid = false;
							problem = 'This field is required';
						}
					} else {
						isValid = true;
						problem = '';
					}
				} else {
					isValid = change.isValid;
					problem = change.problem;
				}
				if (isValid === false) {
					if (!!problem) {
						this.validationError = problem;
					}
					this.validationStates.SetState('invalid');
				} else {
					this.validationStates.SetState('valid');
				}

				this.cdr.detectChanges();
				this.onValidStateChange(this.validationStates.GetCurrentState());
			});
		this.subscriptions.Subscribe(
			this.validator.availMapChange, (changes: AvailabilityDict) => {
				changes = null;
				this.cdr.detectChanges();
			});
		this.subscriptions.Subscribe(this.validator.dataChange, () => {
			this.CleanUp();

		});
		this.initialized = true;
		this.SetAttribute(this.layer, this.attribute);
		this.cdr.detectChanges();
	}
	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		this.Reset();
		if (!!attribute.display) {
			this.label = attribute.display;
		} else {
			this.label = attribute.name;
		}
		this.labelId = attribute.name + '-label';
		this.description = (!!attribute.description) ? attribute.description : '';
		this.describeId = attribute.name + '-desc';
		this.hasDescription = (this.description !== '');
		this.validationError = '';
		this.validationStates.SetState('valid');
		this.isRequired = false;
		if (!!attribute.casting) {
			if (!!attribute.casting.entry) {
				const attCastingEntry = attribute.casting.entry;
				if (!!attCastingEntry.require) {
					this.isRequired = attCastingEntry.require;
				}
			}
		}
		this.reqStates.SetState((this.isRequired === true) ? 'required' : 'optional');
		this.modStates.SetState('unmodified');
		this.onReqStateChange(this.reqStates.GetCurrentState());
		this.onModStateChange(this.reqStates.GetCurrentState());
		this.onValidStateChange(this.validationStates.GetCurrentState());
		layer = null;
		this.currentValue = this.validator.GetValue(this.attribute.name);
		this.cdr.detectChanges();
	}
	Reset() {
		this.labelId = '';
		this.label = '';
		this.description = '';
		this.validationError = '';
		this.validationStates.SetState('valid');
		this.reqStates.SetState('optional');
		this.onReqStateChange(this.reqStates.GetCurrentState());
		this.onModStateChange(this.reqStates.GetCurrentState());
		this.onValidStateChange(this.validationStates.GetCurrentState());
		this.cdr.detectChanges();
	}
	protected onReqStateChange(state: string): void {
		state = state;

	}
	protected onModStateChange(state: string): void {
		state = state;

	}
	protected onValidStateChange(state: string): void {
		state = state;

	}

	public ngOnDestroy() {
		this.CleanUp();
	}
	public CleanUp() {
		this.subscriptions.CancelSubscriptions();
	}
	public GetSuperValue() {
		return this.validator.GetValue(this.attribute.name);
	}

}
